module.exports = __webpack_public_path__ + "static/img/IMG_20170303_150627.38661078.jpg";